import { type ApiResponse, newRequest } from "std/api/newRequest";
import type { ApiBaseParams } from "std/api/types";
import type { ApiProdutor } from "../types/ApiProdutor";

export type ApiProdutorGetParams = ApiBaseParams &
	Omit<Partial<ApiProdutor>, "pessoa" | "rota" | "for_data_cadastro" | "for_rota"> &
	Partial<{
		for_data_cadastro_inicio: string;
		for_data_cadastro_fim: string;
		cpfCnpj: string;
		for_rota_idpk: number;
	}>;

export function apiProdutorGet({ idpk, params }: { idpk?: number; params?: ApiProdutorGetParams }): Promise<ApiResponse<ApiProdutor>> {
	return newRequest({
		url: "Produtor",
		type: "get",
		idpk,
		params,
	});
}
